import { ComponentPropsWithoutRef, FC } from 'react';

type FolderIconProps = ComponentPropsWithoutRef<'svg'>;

export const FolderIcon: FC<FolderIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M2.09834 12.7218C1.78362 12.7218 1.52192 12.6174 1.31322 12.4086C1.10441 12.1999 1 11.9385 1 11.6243V4.1358C1 3.82175 1.11079 3.55394 1.33236 3.33236C1.55394 3.11079 1.82209 3 2.1368 3H5.79365L7.0585 4.26485H12.2508C12.5333 4.26485 12.7733 4.35438 12.9708 4.53344C13.1683 4.71261 13.2875 4.93369 13.3285 5.19667H6.67685L5.41199 3.93182H2.1368C2.07697 3.93182 2.02784 3.95103 1.98944 3.98943C1.95103 4.02784 1.93182 4.07697 1.93182 4.1368V11.4775C1.93182 11.5244 1.94353 11.5629 1.96696 11.5929C1.99049 11.6227 2.02146 11.6483 2.05987 11.6696L3.58665 6.58958H14.601L12.9968 11.9214C12.9186 12.1647 12.7796 12.3589 12.5798 12.504C12.38 12.6492 12.1554 12.7218 11.9061 12.7218H2.09834ZM2.99869 11.79H12.0618L13.3451 7.5214H4.28219L2.99869 11.79Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
